import { Component, OnInit, OnDestroy } from '@angular/core';
import { Field } from '../fields.component';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { FilterByObjectPipe } from 'src/app/shared/pipes/filter/filter-by-object';
import { Subject } from '@shared-logic/subjects/constants/subject.interfaces';
import { brokersSellers$ } from 'src/app/shared/dict/brokers';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-broker-seller',
    templateUrl: './broker-seller.component.html',
    styleUrls: ['./broker-seller.component.scss'],
})
export class BrokerSellerComponent extends Field implements OnInit, OnDestroy {

    public brokers: any = {};
    public arrayBrokers: any[] = [];
    private allBrokers: Subject[] = [];
    private brokerSub!: Subscription;

    constructor(store: Store<appState>) {
        super(store);
        this.pipe = new FilterByObjectPipe();
    }

    ngOnInit(): void {
        // Set tags for NgRx path: order.sellerData.broker
        this.tag = 'sellerData';
        this.subTag = 'broker';
        this.thirdTag = '';

        // Set identifier for click detection
        this.setIdentifyClassName();

        // Subscribe to brokers data
        this.brokerSub = brokersSellers$.subscribe(data => {
            this.allBrokers = data;
            this.brokers = {};
            this.arrayBrokers = [];
            data.forEach(broker => {
                this.brokers[broker._id] = broker.displayName;
                this.arrayBrokers.push(broker._id);
            });
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.brokerSub?.unsubscribe();
    }

    /**
     * Remember the value from the store when the component loads or updates
     */
    override rememberValueInForm() {
        // We handle binding via [value] in the template
    }

    /**
     * Get broker ID selected
     */
    getBrokerSellerSelected(): string {
        const broker = this.rememberValue();
        return broker ? broker.displayName : '';
    }

    /**
     * Handle value selection from select-input
     */
    setValueWithEvent(event: any) {
        // event.element contains the selected key (ID)
        const brokerId = event.element;
        const selectedBroker = this.allBrokers.find(b => b._id === brokerId);

        if (selectedBroker) {
            this.setElementToGenerate(selectedBroker);
        } else {
            // Check if it's a reset or empty selection
            this.setElementToGenerate(null);
        }
    }
}
